import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

// Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyANeMt6BcBrLkKsPLL6ozsuCPbQhV79hUU",
    authDomain: "uwinn-crm.firebaseapp.com",
    projectId: "uwinn-crm",
    storageBucket: "uwinn-crm.firebasestorage.app",
    messagingSenderId: "926675080822",
    appId: "1:926675080822:web:f43553559982b3a5f33157",
    measurementId: "G-KG3HB0BCRM"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Cloud Messaging and get a reference to the service
let messaging = null;

if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  try {
    messaging = getMessaging(app);
  } catch (error) {
    console.error('Firebase messaging initialization error:', error);
  }
}

// Function to get FCM token
export const getFCMToken = async () => {
  if (!messaging) {
    console.error('Messaging not initialized');
    return null;
  }

  try {
    // Request notification permission
    const permission = await Notification.requestPermission();
    
    if (permission === 'granted') {
      // Get registration token
      const token = await getToken(messaging, {
        vapidKey: 'BC3RNis4pwsci7sZsGEnRT0k1p47JpKoZbjYPPDWQkmIsZcw5SR1kXxZZqItdQW2_eqwICcD3ZVWtxTtGg_-0JU' // Replace with your VAPID key
      });
      
      if (token) {
        console.log('FCM Token:', token);
        return token;
      } else {
        console.error('No registration token available.');
        return null;
      }
    } else {
      console.error('Notification permission denied.');
      return null;
    }
  } catch (error) {
    console.error('An error occurred while retrieving token:', error);
    return null;
  }
};

// Function to handle foreground messages
export const onMessageListener = () => {
  return new Promise((resolve) => {
    if (messaging) {
      onMessage(messaging, (payload) => {
        resolve(payload);
      });
    }
  });
};

export { messaging };
export default app;

